{
  "household_name": "Andre's household",
  "week_start_human": "May 12, 2026",
  "due_this_week_count": 3,
  "overdue_count": 1,
  "total_due_human": "$4,287",
  "due_this_week_bills": [
    {
      "name": "Mortgage — primary",
      "payee": "Wells Fargo",
      "amount_human": "$3,210",
      "due_date_human": "May 12",
      "autopay": true
    },
    {
      "name": "Verizon Fios",
      "payee": "Verizon",
      "amount_human": "$95",
      "due_date_human": "May 14",
      "autopay": false
    },
    {
      "name": "ConEd electric",
      "payee": "ConEd",
      "amount_human": "$182",
      "due_date_human": "May 15",
      "autopay": true
    }
  ],
  "overdue_bills": [
    {
      "name": "Pediatric dentist",
      "payee": "Bright Smiles NYC",
      "amount_human": "$800",
      "days_overdue": 4
    }
  ],
  "has_overdue": true,
  "has_due_this_week": true,
  "bills_url": "https://dev.hearthfire.ai/bills"
}
